<div>
  <div class='rate-card-box'>
    <div class='flex rate-card-header'>
      <div class='category-commission'>Category</div>
      <div class='category-commission'>Solv Commission*</div>
    </div>
    <div>
      <div class='flex'>
        <div class='header-key'>{{data.title}}</div>
        <div class='separator'></div>
        <div class='value'> {{data.commissionRate ? data.commissionRate + '%' : ''}}</div>
      </div>
      <div class='separator' style='width:100%;'></div>
      <div *ngFor="let subCat of data.children">
        <div class="flex">
          <div class='category'>{{subCat.title}}</div>
          <div class='separator'></div>
          <div class="value">{{ subCat.commissionRate ? subCat.commissionRate + '%' : '' }}</div>
        </div>
        <div *ngFor="let type of subCat.children">
            <div class='flex background' >
            <div class='key'>{{type.title}}</div>
            <div class='separator'></div>
            <div class='value'> {{type.commissionRate ? type.commissionRate + '%' : ''}}</div>
            </div>
            <div *ngFor="let SubType of type.children" class='flex background-child' >
                <div class='key'>{{SubType.title}}</div>
                <div class='separator'></div>
                <div class='value'> {{SubType.commissionRate ? SubType.commissionRate + '%' : ''}}</div>
            </div>
        </div>
      </div></div>
  </div>
</div>
